export default "__VITE_ASSET__C1a5ouwK__"